import React from 'react'

import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(({ ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.fontSize || '14px'};
  font-style: normal;
  font-weight: ${props => props.fontWeight || 400};
  margin: ${props => props.margin};
  text-align: ${props => props.textAlign};
  text-decoration-line: underline;
`
